<template>
  <div class="employee-register pad">
    <div class="flex">
      <h1 class="title is-3 flex-2">Employee Register</h1>
      <a class="button" target="_blank" :href="$store.getters.apiUrl + '/employee-register'"><fa icon="file-pdf" />&nbsp;PDF</a>
    </div>
    <table class="table is-striped is-bordered is-hoverable" v-if="users && docs">
      <thead>
        <tr>
          <th>Name</th>
          <th>
            <div class="flex">
              <div class="flex-3">Licences / Documents</div>
              <div class="flex-1">#</div>
              <div class="flex-1">Issued</div>
              <div class="flex-1">Expires</div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="user in users" :key="user._id">
          <td>
            <div class="bold font-size-110">{{user.firstName }} {{ user.lastName }}</div>
            <div class="font-size-90">{{ user.phone }}</div>
          </td>
          <td style="padding: 0;">
            <div class="flex doc" v-for="doc in docs[user._id]" :key="doc._id">
              <div class="flex-3">{{ doc.name }}</div>
              <div class="flex-1">{{ doc.number }}</div>
              <div class="flex-1">{{ doc.dateIssued | unixToDateString }}</div>
              <div class="flex-1">{{ doc.dateExpire | unixToDateString }}</div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

  </div>
</template>

<script>
export default {
  data () {
    return {
      users: null,
      docs: null
    }
  },
  created () {
    this.subs.users = this.$fs.collection('users')
      .where('active', '==', true)
      .where('includeInRegister', '==', true)
      .onSnapshot(ss => {
        this.users = this.$ssToArr(ss).sort((a, b) => {
          const aStr = `${a.firstName} ${a.lastName}`.trim().toLowerCase()
          const bStr = `${b.firstName} ${b.lastName}`.trim().toLowerCase()
          return aStr.localeCompare(bStr)
        })
      })
    this.subs.docs = this.$fs.collection('profile-documents')
      .onSnapshot(ss => {
        const docs = {}
        const arr = this.$ssToArr(ss) || []
        for (const doc of arr) {
          let arr = docs[doc.uid]
          if (!arr) {
            arr = []
            docs[doc.uid] = arr
          }
          arr.push(doc)
          arr.sort((a, b) => {
            const aStr = a.name.trim().toLowerCase()
            const bStr = b.name.trim().toLowerCase()
            return aStr.localeCompare(bStr)
          })
        }
        this.docs = docs
      })
  }
}
</script>

<style>
  .employee-register table,
  .employee-register table td,
  .employee-register table th {
    border-color: #333;
  }
  .employee-register .doc {
    border-bottom: solid 1px #ccc;
  }
  .employee-register .doc:last-child {
    border: none;
  }

  .employee-register .doc div {
    padding: 5px;
  }
</style>
